/*
export const someMutation = (state) => {}
 */
import { initialState } from './state'
export default {
  isLoading,
  doneLoading,
  startRefresh,
  endRefresh,
  openUpload,
  closeUpload,
  updateUploadForm,
  setList,
  setDocumentForm,
  clearDocumentForm,
  clearUploadForm,
  clearUploadFormExceptEntityID,
  resetState,
  updateCurrentManagerId,
  setReadingRoster,
}

function isLoading (state) {
  state.loadingData = true
}

function doneLoading (state) {
  state.loadingData = false
}

function startRefresh (state) {
  state.refresh = true
}

function endRefresh (state) {
  state.refresh = false
}

function openUpload (state) { // W
  state.uploadModal.open = true
}

function closeUpload (state) {
  state.uploadModal.open = false
}

function updateCurrentManagerId (state, managerId) {
  state.currentManagerId = managerId
}

function updateUploadForm (state, { field, value }) {
  Object.assign(state.uploadForm, {
    [field]: value
  })
}

function setList (state, { documents }) {
  state.list = documents
}

function setDocumentForm (state, { selectedDocument }) {
  _.each(selectedDocument, (value, key) => {
    state.documentForm[key] = value
  })
}

function clearDocumentForm (state) {
  _.each(state.documentForm, (value, key) => {
    state.documentForm[key] = null
  })
}

function clearUploadForm (state) {
  _.each(state.uploadForm, (value, key) => {
    state.uploadForm[key] = initialState.uploadForm[key]
  })
}

function clearUploadFormExceptEntityID (state) {
  _.each(state.uploadForm, (value, key) => {
    if (key === 'LK_ENTITY_ID') return 
    state.uploadForm[key] = initialState.uploadForm[key]
  })
}

function resetState (state) {
  // _.each(state, (value, key) => {
  //   state[key] = initialState[key]
  // })
  state = { ...initialState }
}

function setReadingRoster(state, payload) {
  state.readingRoster = payload
}